import { useState, useEffect } from 'react';
import api from '../services/api';

export const useFetch = (endpoint, deps = []) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!endpoint) {
            setLoading(false);
            return;
        }

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await api.get(endpoint);
                const result = response.data;

                if (result.status >= 200 && result.status < 300) {
                    setData(result.data);
                    setError(null);
                } else {
                    setError(result.message || 'Unknown error');
                }
            } catch (err) {
                setError(err.message || 'Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [endpoint, ...deps]);

    return { data, loading, error };
};